import { render, staticRenderFns } from "./YourPlanColumnItem.vue?vue&type=template&id=3dd766bb&scoped=true&lang=pug&"
import script from "./YourPlanColumnItem.vue?vue&type=script&lang=js&"
export * from "./YourPlanColumnItem.vue?vue&type=script&lang=js&"
import style0 from "./YourPlanColumnItem.vue?vue&type=style&index=0&id=3dd766bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd766bb",
  null
  
)

export default component.exports